export type SponsoredCallBalanceData = {
  isSponsoredCallAllowed: boolean;
};

const SPONSORED_CALL_BALANCE_DATA: SponsoredCallBalanceData = {
  isSponsoredCallAllowed: false,
};

export function useIsSponsoredCallBalanceAvailable(): SponsoredCallBalanceData {
  return SPONSORED_CALL_BALANCE_DATA;
}
